import React from "react";

const tableHead = [
  "Sr.",
  "Scrap Date",
  "Plant Weight",
  "Plant Price",
];

const PriceWatcherViewTable = ({
  data = [],
  currentPage,
  itemsPerPage,
}) => {
  
  return (
    <div className="table-responsive border-top">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.scrapDate|| "N/A"}</td>
                <td>{item?.plantWeight|| "N/A"}</td>
                <td>₹{item?.plantPrice|| "N/A"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PriceWatcherViewTable;
